$(function () {
  function clearBillSheetLocalStorage() {
    localStorage.removeItem('bill_sheet_export');
    localStorage.removeItem('bill_sheet_not_export');
  }
  
  var isBillSheetPage = window.location.pathname === '/bill_sheets' || 
                        window.location.pathname.match(/^\/bill_sheets($|\/|\?)/);
  
  if (!isBillSheetPage) {
    clearBillSheetLocalStorage();
  }
  
  $(document).on('submit', '#bill_sheet_search, form.bill-sheet-search-form', function() {
    clearBillSheetLocalStorage();
  });
  
  $(document).on('click', '.btn-submit-search-bill, button[type="submit"][form*="bill"]', function() {
    var $form = $(this).closest('form');
    if ($form.length > 0 && $form.attr('action') && $form.attr('action').includes('bill_sheets')) {
      clearBillSheetLocalStorage();
    }
  });
  
  $(window).on('beforeunload', function() {
    var isLeavingBillSheetPage = !window.location.pathname.match(/^\/bill_sheets($|\/|\?)/);
    if (isLeavingBillSheetPage) {
      clearBillSheetLocalStorage();
    }
  });
  
  $(window).on('pageshow', function(event) {
    if (event.persisted || performance.navigation.type === 2) {
      
      var exportValue = localStorage.getItem('bill_sheet_export');
      var notExportValue = localStorage.getItem('bill_sheet_not_export');
      
      if (!exportValue && !notExportValue) {
        $('#check_all').prop('checked', false);
        $("input[name='check_bill[]']").prop('checked', false);
        check_checked();
      } else {
        restoreCheckboxesFromLocalStorage();
      }
    }
  });
  
  function restoreCheckboxesFromLocalStorage() {
    try {
      var exportValue = localStorage.getItem('bill_sheet_export');
      var notExportValue = localStorage.getItem('bill_sheet_not_export');
            
      if (!exportValue) {
        $('#check_all').prop('checked', false);
        $("input[name='check_bill[]']").prop('checked', false);
        check_checked();
        return;
      }
      
      var allCheckboxes = $("input[name='check_bill[]']");
      if (allCheckboxes.length === 0) {
        return;
      }
      
      if (exportValue === 'all') {
        allCheckboxes.prop('checked', true);
        
        if (notExportValue) {
          var notExportIds = notExportValue.split(',').filter(function(id) {
            return id.trim() !== '';
          });
                    
          notExportIds.forEach(function(id) {
            var $checkbox = $("input[name='check_bill[]'][value='" + id.trim() + "']");
            if ($checkbox.length > 0) {
              $checkbox.prop('checked', false);
            }
          });
          $('#check_all').prop('checked', false);
        } else {
          $('#check_all').prop('checked', true);
        }
        
      } else {
        var exportIds = exportValue.split(',').filter(function(id) {
          return id.trim() !== '';
        });
                
        $('#check_all').prop('checked', false);
        allCheckboxes.prop('checked', false);
        
        exportIds.forEach(function(id) {
          var $checkbox = $("input[name='check_bill[]'][value='" + id.trim() + "']");
          if ($checkbox.length > 0) {
            $checkbox.prop('checked', true);
          }
        });
      }
      
      check_checked();
    } catch (error) {
      console.error('Error restoring checkboxes:', error);
    }
  }
  
  if (isBillSheetPage) {    
    setTimeout(function() {
      restoreCheckboxesFromLocalStorage();
    }, 200);
  }

  $(document).on('change', '#check_all', function () {
    if ($(this).is(':checked')) {
      $('.tbody-bill-sheet').find('.check_box_bill').prop('checked', true);
      
      localStorage.setItem('bill_sheet_export', 'all');
      localStorage.removeItem('bill_sheet_not_export');
    } else {
      $('.tbody-bill-sheet').find('.check_box_bill').prop('checked', false);
      
      localStorage.removeItem('bill_sheet_export');
      localStorage.removeItem('bill_sheet_not_export');
    }
    check_checked();
  })

  $(document).on('change', '.check_box_bill', function () {    
    updateLocalStorageBillSheets(this);
    var exportValue = localStorage.getItem('bill_sheet_export');
    var notExportValue = localStorage.getItem('bill_sheet_not_export');
    
    if (exportValue === 'all') {
      if (notExportValue && notExportValue.length > 0) {
        $('#check_all').prop('checked', false);
      } else {
        $('#check_all').prop('checked', true);
      }
    } else {
      var allCheckboxes = $("input[name='check_bill[]']");
      var checkedCheckboxes = allCheckboxes.filter(':checked');
      
      if (allCheckboxes.length === checkedCheckboxes.length && allCheckboxes.length > 0) {
        $('#check_all').prop('checked', true);
        localStorage.setItem('bill_sheet_export', 'all');
        localStorage.removeItem('bill_sheet_not_export');
      } else {
        $('#check_all').prop('checked', false);
      }
    }
    
    check_checked();
  })

  $(document).on('click', '#show_print_list', function () {
    var exportValue = localStorage.getItem('bill_sheet_export');
    var notExportValue = localStorage.getItem('bill_sheet_not_export');
        
    if (!exportValue) {
      alert('請求書を選択してください');
      return;
    }
    
    reset_radio();
    setKoraboKagamiRestriction($('#print_list'), $('.check_box_bill:checked[data-project-type="korabo"]').length > 0);
    
    var $form = $('#print_list').find('form');
    $form.find('.url-param-field').remove();
    
    var billSheetIds;
    if (exportValue === 'all') {
      billSheetIds = 'all';
      
      if (notExportValue) {
        $('<input>')
          .attr({
            type: 'hidden',
            name: 'excluded_ids',
            value: notExportValue,
            class: 'url-param-field'
          })
          .appendTo($form);
      }
      
      var urlParams = new URLSearchParams(window.location.search);
      
      urlParams.forEach(function(value, key) {
        if (key !== 'authenticity_token' && key !== 'commit' && key !== 'utf8') {
          $('<input>')
            .attr({
              type: 'hidden',
              name: key,
              value: value,
              class: 'url-param-field'
            })
            .appendTo($form);
        }
      });
      
    } else {
      billSheetIds = exportValue;
    }
    
    $form.find('#bill_sheet_ids').val(billSheetIds);
    $form.attr('action', '/export/bill_sheets');    
    $('#print_list').modal('show');
  })

  $(document).on('click', '.print_billing', function () {
    var id = $(this).data('id');
    reset_radio();
    setKoraboKagamiRestriction($('#print_bill'), $(this).data('project-type') === 'korabo');
    $('#print_bill').find('#bill_sheet_ids').val(id);
    $('#print_bill').modal('show');
  })

  $(document).on('click', '#btn_rakuraku', function () {
    var rakurakuIds = []
    $('.check_box_bill:checked').each(function () {
      rakurakuIds.push(this.value);
    });

    $.ajax({
      url: `/bill_sheets/rakuraku_update_all`,
      data: { bill_sheet_ids: rakurakuIds },
      method: 'POST',
    });
  })

  function update_status_print(bill_sheet_id) {
    $.ajax({
      url: `/bill_sheets/${bill_sheet_id}/status_print`,
      method: 'POST',
    });
  }

  function intevarCheckStatus(time, bill_sheet_id) {
    var count = 0;
    var setIntever = setInterval(function () {
      count++;
      if (count > time) {
        clearInterval(setIntever);
      }
      update_status_print(bill_sheet_id);
    }, 1000);
  }

  $(document).on('click', '#submit-export', function () {
    $(this).closest('form').submit();
    var bill_sheet_id = $(this).closest('form').find('#bill_sheet_ids').val()

    setTimeout(() => {
      intevarCheckStatus(3, bill_sheet_id);
      $('#print_list').modal('hide');
      $('#print_bill').modal('hide');
      
      clearBillSheetLocalStorage();
      $('#check_all').prop('checked', false);
      $("input[name='check_bill[]']").prop('checked', false);
      check_checked();
    }, 2000);
  })

  function reset_radio() {
    $("input[name=pdf_type][value=client]").prop('checked', 'checked');
    $("input[name=kagami_type][value=1]").prop('checked', 'checked');
    $("input[name=format_type][value=1]").prop('checked', 'checked');
  }

  function setKoraboKagamiRestriction($modal, isKorabo) {
    var $withoutCover = $modal.find("input[name=kagami_type][value='2']");
    $withoutCover.prop('disabled', isKorabo);
    $withoutCover.closest('.form-check').toggleClass('text-muted', isKorabo);
    if (isKorabo) {
      $modal.find("input[name=kagami_type][value='1']").prop('checked', true);
    }
  }

  function check_checked() {
    if ($('.check_box_bill').is(":checked")) {
      $('#show_print_list').find('span').removeClass('background-gray');
      $('#btn_rakuraku').prop('disabled', false);
    } else {
      $('#show_print_list').find('span').addClass('background-gray');
      $('#btn_rakuraku').prop('disabled', true);
    }
  }

  $(document).on('click', '#btn-show-modal-alert-bill', function() {
    var ordered_item_id = $(this).data('ordered-item');
    var project_id = $(this).data('project-id');
    $('#btn-groups').html(`
      <a class="a-none-decoration" data-remote="true" href="/bill_sheets/new?from_page=project_edit&amp;ordered_item_id=${ordered_item_id}&amp;project_id=${project_id}">
          <button class="btn btn-primary create-bill-sheet tw-w-[130px]">請求書作成</button>
      </a>
      `)
    $('#modal-alert-bill-sheet').modal('show');
  })

  function updateLocalStorageBillSheets(changedCheckbox) {
    var exportValue = localStorage.getItem('bill_sheet_export');
    var notExportValue = localStorage.getItem('bill_sheet_not_export');
    
    if (changedCheckbox) {
      var id = $(changedCheckbox).val();
      var isChecked = $(changedCheckbox).is(':checked');
            
      if (exportValue === 'all') {
        if (isChecked) {
          if (notExportValue) {
            var notExportIds = notExportValue.split(',').filter(function(existingId) {
              return existingId !== id;
            });
            
            if (notExportIds.length > 0) {
              localStorage.setItem('bill_sheet_not_export', notExportIds.join(','));
            } else {
              localStorage.removeItem('bill_sheet_not_export');
            }
          }
        } else {
          var notExportIds = notExportValue ? notExportValue.split(',') : [];
          
          if (!notExportIds.includes(id)) {
            notExportIds.push(id);
            localStorage.setItem('bill_sheet_not_export', notExportIds.join(','));
          }
        }
        
      } else {
        if (isChecked) {
          var exportIds = exportValue ? exportValue.split(',') : [];
          
          if (!exportIds.includes(id)) {
            exportIds.push(id);
            localStorage.setItem('bill_sheet_export', exportIds.join(','));
          }
        } else {
          if (exportValue) {
            var exportIds = exportValue.split(',').filter(function(existingId) {
              return existingId !== id;
            });
            
            if (exportIds.length > 0) {
              localStorage.setItem('bill_sheet_export', exportIds.join(','));
            } else {
              localStorage.removeItem('bill_sheet_export');
            }
          }
        }
      }
    }
  }

  $("#modal-create-bill-sheet .js-position").each(function (index) {
    $(this).val(index);
  });

  $("#modal-create-bill-sheet .bill-item-fields").each(function (index) {
    updateBillPadding($(this));
  });

  $(document).on("change", "#modal-create-bill-sheet .bill-level-select", function () {
    let $row = $(this).closest(".bill-item-fields");
    let level = parseInt($(this).val(), 10);
    let $inputs = $row.find(".input-field");
    if (level === 1 || level === 2 || level === 3) {
      $inputs.prop("disabled", true);
    } else {
      $inputs.prop("disabled", false);
    }
    updateBillPadding($row)

  });

  $(document).on("change", "#modal-create-bill-sheet .js-product-text-bill", function () {
    let $row = $(this).closest(".bill-item-fields");
    updateBillPadding($row)
  });

  $('.bill-level-select').trigger('change');

  function calculateBillSellingPrice($row) {
    let level = parseInt($row.find(".bill-level-select").val(), 10);
    let totalPrice = 0;
    if ([1, 2, 3].includes(level)) {
        let groupRows = getGroupRows($row);
        let blankItems = groupRows.filter(function () {
          let childRowLevel = parseInt($(this).find(".bill-level-select").val(), 10);
          let isBlankItem = isNaN(childRowLevel);
          let isVisible = $(this).is(":visible");

          if (level === 3) {
            return isVisible && isBlankItem &&
              $(this).prevAll(".bill-item-fields").filter(function () {
                let nextLevel = parseInt($(this).find(".bill-level-select").val(), 10)
                  return nextLevel === 3 || nextLevel === 2;
              }).first().is($row)
          } else if (level === 2) {
          return isVisible && isBlankItem &&
              $(this).prevAll(".bill-item-fields").filter(function () {
                  return parseInt($(this).find(".bill-level-select").val(), 10) === 2;
              }).first().is($row)
          } else if (level === 1) {
            return isVisible && isBlankItem;
          }
          return false;
        });

        blankItems.each(function () {
            let priceText = $(this).find(".js_total_price").val();
            if (priceText !== undefined && priceText !== null) {
                let price = parseFloat(priceText.replace(/,/g, "")) || 0;
                totalPrice += price;
            }
        });
        $row.find(".js-total-price").attr('data-value', totalPrice.toLocaleString('en-US'));

        let formattedPrice = totalPrice < 0 ?
          '-￥' + Math.abs(totalPrice).toLocaleString('en-US') :
          '￥' + totalPrice.toLocaleString('en-US');

        $row.find(".js-total-price span").text(formattedPrice)
        $row.find(".js_total_price").val(totalPrice.toLocaleString('en-US'));
    }
  }

  window.updateBillAllPrices = function() {
    $($("#modal-create-bill-sheet .bill-item-fields:visible").get().reverse()).each(function () {
      calculateBillSellingPrice($(this));
    });
  }

  $(document).on("change", ".bill-level-select, .js-amount, .js-price", function () {
    updateBillAllPrices();
  });
  updateBillAllPrices();

  $("#modal-create-bill-sheet .bill-level-select").each(function () {
    let $row = $(this).closest(".bill-item-fields");
    let currentLevel = $(this).val();
    $row.data("previousLevel", currentLevel || "");
  });

  $(document).on("focus", "#modal-create-bill-sheet .bill-level-select", function () {
    let $row = $(this).closest(".bill-item-fields");
    let currentLevel = $(this).val();
    $row.data("previousLevel", currentLevel || "");
  });

  $(document).on("change", "#modal-create-bill-sheet .bill-level-select", function () {
      let $row = $(this).closest(".bill-item-fields");
      let previousLevel = $row.data("previousLevel") || "";
      let newLevel = $(this).val() || "";

      if ((previousLevel && !newLevel) || (!previousLevel && newLevel)) {
          $row.find(".js-amount, .js-price, .js-cost-price").val("");
      }

      $row.data("previousLevel", newLevel);
  });

  function getGroupRows($row) {
    let groupRows = [];
    let currentRow = $row;
    let level = parseInt($row.find('.bill-level-select').val(), 10);

    while (currentRow.next().length > 0) {
      let nextRow = currentRow.next();

      if (!nextRow.is(':visible')) {
          currentRow = nextRow;
          continue;
      }

      let nextLevel = parseInt(nextRow.find(".bill-level-select").val(), 10);

      if ([3, 2].includes(level) && level === nextLevel) break;
      if (!isNaN(nextLevel) && nextLevel === 1) break;

      groupRows.push(nextRow);
      currentRow = nextRow;
    }
    return $(groupRows);
  }

  $(document).on("click", "#modal-create-bill-sheet .btn-add-bill-item", function () {
    let $currentRow = $(this).closest(".bill-item-fields");
    $currentRow.find("select.select2").select2("destroy");

    let $newRow = $currentRow.clone(true);
    $newRow.find("select.select2").each(function () {
      $(this).removeAttr("data-select2-id");
      $(this).removeAttr("aria-hidden");
    });
    $newRow.find("select.select2").val([]).trigger("change");
    $currentRow.after($newRow);
    $newRow.find(".input-field").prop("disabled", false);
    $newRow.find(".bill-level-select, .js-amount, .js-price, .js-product-text-bill").not(".js-sell_price").val("");
    $newRow.find(".js_total_price").val(0);
    $newRow.find(".js-total-price").attr('data-value', 0);
    $newRow.find(".js-total-price span").text('￥' + 0)

    $newRow.find(".parent-fields").css('background-color', '');

    $newRow.find("select.select2").each(function () {
      $(this).removeAttr("data-select2-id");
      $(this).removeAttr("aria-hidden");
    });
    $newRow.find("select.select2").val([]).trigger("change");
    $newRow.find("input, select").each(function () {
      let timestamp = Date.now();
      let name = $(this).attr("name");
                  if (name) {
          name = name.replace(/\[bill_items_attributes\]\[\d+\]/, "[bill_items_attributes][" + timestamp + "]");
          $(this).attr("name", name);
      }
    });

    $(".bill-item-fields").each(function (index) {
      $(this).find(".js-position").val(index);
    });
    $("select.select2").select2({theme: "bootstrap"});
    updateBillAllPrices();
  });

  $(document).on('change', '#bill_sheet_sending_place_id', function () {
    var client_id = $(this).val()
    if(client_id != undefined && client_id != ""){
      $.ajax({
        url: '/client_companies/' + client_id,
        method: 'get',
        dataType: 'json',
        success: function(res) {
          if (res.is_rakuraku) {
            $('#bill_sheet_is_rakuraku').prop('checked', true);
            $('#bill_sheet_is_rakuraku').attr('disabled', false);
          } else {
            $('#bill_sheet_is_rakuraku').prop('checked', false);
            $('#bill_sheet_is_rakuraku').attr('disabled', true);
          }
        }
      })
    }
  })

  $(document).on('change', '#bill_sheet_sending_place_lease_company_id', function () {
    var lease_company_id = $(this).val()
    if(lease_company_id != undefined && lease_company_id != ""){
      $.ajax({
        url: '/lease_companies/' + lease_company_id + '/check_is_rakuraku',
        method: 'get',
        dataType: 'json',
        success: function(res) {
          if (res.is_rakuraku) {
            $('#bill_sheet_is_rakuraku').prop('checked', true);
            $('#bill_sheet_is_rakuraku').attr('disabled', false);
          } else {
            $('#bill_sheet_is_rakuraku').prop('checked', false);
            $('#bill_sheet_is_rakuraku').attr('disabled', true);
          }
        }
      })
    }
  })

  function updateBillPadding($row) {
    let level = parseInt($row.find(".bill-level-select").val(), 10);
    $productText = $row.find('.js-product-text-bill')
    if (level === 1) {
      $productText.css("text-indent", "0px");
      $row.find('.row').css('background-color', 'rgba(96, 142, 215, 1)');
    }
    else if (level === 2) {
      $productText.css("text-indent", "10px");
      $row.find('.row').css('background-color', 'rgba(161, 209, 238, 1)');
    } else if (level === 3) {
      $productText.css("text-indent", "20px");
      $row.find('.row').css('background-color', 'rgba(210, 229, 249, 1)');
    } else {
      $productText.css("text-indent", "30px");
      $row.find('.row').css('background-color', '');
    }
  }
})
